import type { TFunction } from 'i18next';
import React from 'react';

import { DestructiveConfirmation } from 'src/modules/homeownerApp/components/DestructiveConfirmation';
import { Actions } from 'src/modules/homeownerApp/components/Projects/Menu/MoreActions/types';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

type DestructiveConfirmationProps = {
  action: Actions;
  deleteAction: () => void;
  deleteText?: string;
  headerText?: string;
  subHeaderText?: string;
  trackId: string;
  buttonLocation: string;
};

const getDestructiveConfirmationProps = (
  t: TFunction<'homeownerApp'>,
  action: Actions,
):
  | Omit<DestructiveConfirmationProps, 'deleteAction' | 'action'>
  | undefined => {
  switch (action) {
    case Actions.DELETE_CONFIRMATION:
      return {
        deleteText: t('projects.confirmation.delete.delete'),
        headerText: t('projects.confirmation.delete.header'),
        subHeaderText: t('projects.confirmation.delete.confirmationText'),
        trackId: 'delete-confirm',
        buttonLocation: 'delete-confirmation',
      };
    case Actions.REMOVE_SCAN:
      return {
        deleteText: t('projects.confirmation.removeScan.delete'),
        headerText: t('projects.confirmation.removeScan.header'),
        subHeaderText: t('projects.confirmation.removeScan.confirmationText'),
        trackId: 'remove-scan-from-project',
        buttonLocation: 'remove-scan-module',
      };
    default:
      return undefined;
  }
};

export const DisplayDestructiveConfirmation = ({
  action,
  deleteAction,
}: Omit<DestructiveConfirmationProps, 'trackId' | 'buttonLocation'>) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const confirmationProps = getDestructiveConfirmationProps(t, action);
  if (!confirmationProps) return null;

  return (
    <DestructiveConfirmation
      deleteAction={deleteAction}
      {...confirmationProps}
    />
  );
};
